export function getGroupLessonAwards(state, sessionId) {
  return state.getIn(['rootReducer', 'groupLessonAwards', `${sessionId}`]);
}



// WEBPACK FOOTER //
// ./data/GroupLessonAwards/accessors.js